import { Button, IconArrowLeft } from '@veneer/core';
import { useEffect, useState } from 'react';
import { LocalStorageHelper } from '../../helpers/localStorage';
import './index.css';

interface HeaderBarProps {
  handleBack: () => void;
  title: string;
  colorBackground?: boolean;
}

const HeaderBar = (props: HeaderBarProps) => {
  const [activeUserDevice, setActiveUserDevice] = useState('');

  useEffect(() => {
    const device = LocalStorageHelper.getDevice();
    setActiveUserDevice(device ?? '');
  }, []);

  return (
    <header className={`headerBar ${activeUserDevice ?? ''} ${props.colorBackground === true ? 'color' : ''}`}>
      <Button
        leadingIcon={<IconArrowLeft />}
        aria-label="Profile"
        appearance="ghost"
        onClick={props.handleBack}
      ></Button>
      <span className="page-title">{props.title}</span>
    </header>
  );
};

export default HeaderBar;
